import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Ise järgi

  <span style="color:#85c1dc;">**FI:**</span>
  Nouto

  <span style="color:#85c1dc;">**RU:**</span>
  Забрать со склада
*/
/* @__NO_SIDE_EFFECTS__ */
const m1148 = msg(
  mf`Ise järgi`,
  mf`Nouto`,
  mf`Забрать со склада`,
)

export { m1148 as 'w.basket.delivery.self_pickup' }